import { render, staticRenderFns } from "./CompanySettingButton.vue?vue&type=template&id=3636b77c"
import script from "./CompanySettingButton.vue?vue&type=script&lang=js"
export * from "./CompanySettingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports